<template>
  <div class="page-listing-item pb-3 pb-lg-5 mb-3 mb-lg-5">
    <div class="row">
      <div v-if="item.image?.url" class="col-12 col-lg-3 mb-3 mb-lg-0">
        <a :href="item.link" aria-label="news image link">
          <div class="image-wrap">
            <img :src="item.image.url" :alt="item.image.alt">
          </div>
        </a>
      </div>
      <div class="col-12 col-lg-9 d-flex flex-column page-teaser">
        <h3 class="text-uppercase mb-3"><a class="link-black underline-thin" :target="item.target" :href="item.link" alt="news title link">{{ item.title }}</a></h3>
        <div class="eyebrow text-primary text-uppercase">{{ dateDisplay }}</div>
        <div v-if="item.description" class="rte" v-html="item.description"></div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['item'],
    computed: {
      dateDisplay() {
        let date = new Date(Date.parse(this.item.date));
        return date.toLocaleDateString();
      }
    }
  }
</script>
